import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4f5d6d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-footer" }
const _hoisted_2 = { class: "life-back-section" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "get-buttons" }
const _hoisted_5 = { class: "d-flex flex-direction-column align-items-start" }
const _hoisted_6 = { class: "d-flex flex-direction-column align-items-start" }
const _hoisted_7 = { class: "faq-section" }
const _hoisted_8 = { class: "faq-box" }
const _hoisted_9 = { class: "d-flex justify-content-center" }
const _hoisted_10 = { class: "faq-container" }
const _hoisted_11 = { class: "landing-footer__menu-container" }
const _hoisted_12 = { class: "mobile-only" }
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = { class: "mt-2 social-text" }
const _hoisted_15 = { class: "landing-footer__social-links" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "landing-footer__menu" }
const _hoisted_20 = { class: "landing-footer__menu__links" }
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "landing-footer__menu" }
const _hoisted_24 = { class: "landing-footer__menu__links" }
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "landing-footer__menu" }
const _hoisted_28 = { class: "landing-footer__menu__links" }
const _hoisted_29 = { class: "w-100 d-flex justify-content-center" }
const _hoisted_30 = { class: "desktop-only" }
const _hoisted_31 = { class: "mt-2" }
const _hoisted_32 = { class: "mt-2 social-text" }
const _hoisted_33 = { class: "landing-footer__social-links" }
const _hoisted_34 = ["href"]
const _hoisted_35 = ["href"]
const _hoisted_36 = ["href"]

import { IonImg, IonCol, IonGrid, IonRow, IonIcon, IonText } from "@ionic/vue";
import FaqItem from "@/landing/components/landing/FaqItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingFooterStatic',
  setup(__props) {

const VUE_APP_APPSTORE = process.env.VUE_APP_APPSTORE;
const VUE_APP_PLAYSTORE = process.env.VUE_APP_PLAYSTORE;
const VUE_APP_PRIVACY = process.env.VUE_APP_PRIVACY;
const VUE_APP_EULA = process.env.VUE_APP_EULA;
const VUE_APP_INSTAGRAM = process.env.VUE_APP_INSTAGRAM;
const VUE_APP_FB = process.env.VUE_APP_FB;
const VUE_APP_TWITTER = process.env.VUE_APP_TWITTER;

const openUrl = (url: string) => {
  window.open(url);
}

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createVNode(_unref(IonText), { class: "lg-title" }, {
            default: _withCtx(() => [
              _createTextVNode("Spot, Sweat, Repeat")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(IonText), { class: "sm-title" }, {
            default: _withCtx(() => [
              _createTextVNode("Spotter is available on both iOS and Android")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ion_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openUrl(_unref(VUE_APP_PLAYSTORE)))),
          class: "get-button"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), {
              class: "button-icon",
              src: "assets/icon/google-play.svg"
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(IonText), { class: "get-button__small-text" }, {
                default: _withCtx(() => [
                  _createTextVNode("GET IT ON")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonText), { class: "get-button__text" }, {
                default: _withCtx(() => [
                  _createTextVNode("Google Play")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openUrl(_unref(VUE_APP_APPSTORE)))),
          class: "get-button"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), {
              class: "button-icon",
              src: "assets/icon/apple.svg"
            }),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(IonText), { class: "get-button__small-text" }, {
                default: _withCtx(() => [
                  _createTextVNode("Download on the")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonText), { class: "get-button__text" }, {
                default: _withCtx(() => [
                  _createTextVNode("App Store")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(IonText), { class: "md-title faq-box__title" }, {
            default: _withCtx(() => [
              _createTextVNode("Frequently asked questions")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(FaqItem, {
            question: "What is the guarantee that my message would be replied?",
            answer: "It would definitely be replied because there is an incentive for the recipient of your message to make money when he or she does that."
          }),
          _createVNode(FaqItem, {
            question: "Are my personal details secured?",
            answer: "It would definitely be replied because there is an incentive for the recipient of your message to make money when he or she does that."
          }),
          _createVNode(FaqItem, {
            question: "What is your refund policy?",
            answer: "It would definitely be replied because there is an incentive for the recipient of your message to make money when he or she does that."
          }),
          _createVNode(FaqItem, {
            question: "Can i delete my account?",
            answer: "It would definitely be replied because there is an incentive for the recipient of your message to make money when he or she does that."
          })
        ])
      ])
    ]),
    _createVNode(_unref(IonGrid), {
      fixed: true,
      class: "footer-bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "12",
              "size-lg": "8"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(IonImg), {
                      src: "assets/icon/logo-complete.png",
                      class: "logo",
                      alt: "logo"
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_unref(IonText), null, {
                        default: _withCtx(() => [
                          _createTextVNode(" Be in total control of your life, one session at a time. ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_unref(IonText), null, {
                        default: _withCtx(() => [
                          _createTextVNode(" STAY IN TOUCH ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("a", {
                        href: _unref(VUE_APP_FB),
                        class: "landing-footer__social-links__link"
                      }, [
                        _createVNode(_unref(IonIcon), { src: "assets/icon/facebook.svg" })
                      ], 8, _hoisted_16),
                      _createElementVNode("a", {
                        href: _unref(VUE_APP_TWITTER),
                        class: "landing-footer__social-links__link"
                      }, [
                        _createVNode(_unref(IonIcon), { src: "assets/icon/twitter.svg" })
                      ], 8, _hoisted_17),
                      _createElementVNode("a", {
                        href: _unref(VUE_APP_INSTAGRAM),
                        class: "landing-footer__social-links__link"
                      }, [
                        _createVNode(_unref(IonIcon), { src: "assets/icon/instagram.svg" })
                      ], 8, _hoisted_18)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_unref(IonText), { class: "landing-footer__menu-title" }, {
                      default: _withCtx(() => [
                        _createTextVNode("DOWNLOAD")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("a", {
                        href: _unref(VUE_APP_APPSTORE),
                        class: "landing-footer__menu-item"
                      }, " iOS ", 8, _hoisted_21),
                      _createElementVNode("a", {
                        href: _unref(VUE_APP_PLAYSTORE),
                        class: "landing-footer__menu-item"
                      }, " Android ", 8, _hoisted_22)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_unref(IonText), { class: "landing-footer__menu-title" }, {
                      default: _withCtx(() => [
                        _createTextVNode("LEGAL")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("a", {
                        href: _unref(VUE_APP_EULA),
                        class: "landing-footer__menu-item"
                      }, " Terms & Conditions ", 8, _hoisted_25),
                      _createElementVNode("a", {
                        href: _unref(VUE_APP_PRIVACY),
                        class: "landing-footer__menu-item"
                      }, " Privacy Policy ", 8, _hoisted_26)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_unref(IonText), { class: "landing-footer__menu-title" }, {
                      default: _withCtx(() => [
                        _createTextVNode("ABOUT US")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_router_link, {
                        to: "/how-it-works",
                        class: "landing-footer__menu-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Step-by-step instruction ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: "/faqs",
                        class: "landing-footer__menu-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" FAQs ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: "/contact-us",
                        class: "landing-footer__menu-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Contact us ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol)),
            _createVNode(_unref(IonCol), {
              size: "12",
              "size-lg": "3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_unref(IonImg), {
                      src: "assets/icon/logo-complete.png",
                      class: "logo",
                      alt: "logo"
                    }),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_unref(IonText), null, {
                        default: _withCtx(() => [
                          _createTextVNode(" Be in total control of your life, one session at a time. ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_unref(IonText), null, {
                        default: _withCtx(() => [
                          _createTextVNode(" STAY IN TOUCH ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("a", {
                        href: _unref(VUE_APP_FB),
                        class: "landing-footer__social-links__link"
                      }, [
                        _createVNode(_unref(IonIcon), { src: "assets/icon/facebook.svg" })
                      ], 8, _hoisted_34),
                      _createElementVNode("a", {
                        href: _unref(VUE_APP_TWITTER),
                        class: "landing-footer__social-links__link"
                      }, [
                        _createVNode(_unref(IonIcon), { src: "assets/icon/twitter.svg" })
                      ], 8, _hoisted_35),
                      _createElementVNode("a", {
                        href: _unref(VUE_APP_INSTAGRAM),
                        class: "landing-footer__social-links__link"
                      }, [
                        _createVNode(_unref(IonIcon), { src: "assets/icon/instagram.svg" })
                      ], 8, _hoisted_36)
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})